import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Card,
  CardContent,
  Avatar,
  Typography,
  Button,
  Box,
  CircularProgress
} from '@mui/material';
import { useParams } from 'react-router';

function ImportAsanaDialogs({ open, onClose, asanas = [], onSelect, isLoading, isError }) {
  const [selectedAsanaId, setSelectedAsanaId] = useState(null);
  const { courseid } = useParams;
  const handleClickAsana = (asana) => {
    console.log('Selected asana in dialog:', asana); // Debug log
    setSelectedAsanaId(asana.id);
  };

  const handleConfirm = () => {
    const selectedAsana = asanas.find((a) => a.id === selectedAsanaId);
    if (selectedAsana) {
      console.log('Confirming asana:', selectedAsana); // Debug log
      onSelect(selectedAsana);
      setSelectedAsanaId(null);
      onClose();
    }
  };

  const asanasWithImage = asanas.filter((a) => a.image && a.image.trim() !== '');

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Select Asana</DialogTitle>
      <DialogContent dividers>
        {isLoading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : isError ? (
          <Typography color="error">Error loading library</Typography>
        ) : asanasWithImage.length === 0 ? (
          <Typography>No asanas with images available</Typography>
        ) : (
          <Grid container spacing={2}>
            {asanasWithImage.map((asana) => {
              const isSelected = selectedAsanaId === asana.id;
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={asana.id}>
                  <Card
                    sx={{
                      cursor: 'pointer',
                      border: isSelected ? '2px solid #1976d2' : '1px solid #ccc',
                      transition: 'border 0.2s',
                      '&:hover': { boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }
                    }}
                    onClick={() => handleClickAsana(asana)}
                  >
                    <Avatar
                      src={asana.image}
                      alt={asana.posturename || asana.name}
                      variant="rounded"
                      sx={{ width: '100%', height: 180, borderRadius: 0 }}
                    />
                    <CardContent>
                      <Typography fontWeight={600} color={isSelected ? '#1976d2' : 'black'} textAlign="center">
                        {asana.posturename || asana.name || 'No Name'}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          p: 2,
          borderTop: '1px solid #ddd',
          backgroundColor: 'background.paper',
          position: 'sticky',
          bottom: 0
        }}
      >
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!selectedAsanaId} onClick={handleConfirm}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ImportAsanaDialogs;
